export function downloadFile(response, filename) {
  const blob = new Blob([response.data])
  if (window.navigator?.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob)
    return
  }
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  setTimeout(() => window.URL.revokeObjectURL(url), 100)
}
